import type React from 'react';

import { useStepInternalParticipants } from '@/hooks/createSix/useStepInternalParticipants';
import StepInternalParticipantsView from '@/components/organism/CreateSix/steps/StepInternalParticipants/StepInternalParticipants.view';

export interface StepInternalParticipantsProps {
  onClose: () => void;
}

export function StepInternalParticipants(props: StepInternalParticipantsProps): React.JSX.Element {
  void props;

  const { state, handlers } = useStepInternalParticipants();

  return (
    <StepInternalParticipantsView
      selectedMembers={state.selectedMembers}
      candidateMembers={state.candidateMembers}
      searchValue={state.searchValue}
      onSearchValueChange={handlers.handleSearchValueChange}
      onRemoveMember={handlers.handleRemoveMember}
      onAddMember={handlers.handleAddMember}
    />
  );
}

StepInternalParticipants.displayName = 'StepInternalParticipants';

export default StepInternalParticipants;
